export default __webpack_public_path__ + "static/ToktamHarkati-4a7b698456d60bc61ffca8313cecf62b.png";